import React from 'react';
import { CenteredModal } from '@app/core';
import { Participant } from '@app/api';
import { VerifyEmailViaCodeContent } from './VerifyEmailViaCodeContent';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onRequestClose: () => any;
  email?: string;
  participantId?: string;
  onSuccess?: (participant: Participant) => any;
}

export const VerifyEmailViaCodeModal = ({
  email,
  isOpen,
  onRequestClose,
  participantId,
  onSuccess,
}: Props) => {
  const { t } = useTranslation('common');
  return (
    <CenteredModal
      title={t('login.emailVerificationValidationCode.title')}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <VerifyEmailViaCodeContent
        text={t('login.emailVerificationValidationCode.text')}
        email={email}
        sentText={t('login.emailVerificationValidationCode.sent')}
        displayed={isOpen}
        participantId={participantId}
        onSuccess={onSuccess}
      />
    </CenteredModal>
  );
};
